/** Coarse "how long ago" label. Minutes are its finest step past the first one. */
export function relativeTime(at: number, now: number): string {
  const secs = Math.floor((now - at) / 1000)
  if (secs < 60) return "just now"
  const mins = Math.floor(secs / 60)
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  return new Date(at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
}
